import { LoyaltyType } from './loyalty-type.enum';
import { LOYALTY_STATUS } from './loyalty-status-type.enum';

export class LoyaltyStatus {
  private _disabledStatus = [
    LOYALTY_STATUS.COMING_SOON,
    LOYALTY_STATUS.LIMIT_REACHED,
    LOYALTY_STATUS.NOT_ENOUGH_POINTS,
    LOYALTY_STATUS.SOLD_OUT,
    LOYALTY_STATUS.LOCKED,
  ];
  theme: string;
  status: LOYALTY_STATUS;
  type: LoyaltyType;

  constructor(o?: Partial<LoyaltyStatus>) {
    o = o || {};
    this.theme = o.theme || '';
    this.status = o.status || LOYALTY_STATUS.NONE;
    this.type = o.type || LoyaltyType.NONE;
  }

  get disabled(): boolean {
    return this._disabledStatus.some((status) => status === this.status);
  }
}
